import { render, staticRenderFns } from "./superuser_dashboard.vue?vue&type=template&id=90adaff2&scoped=true&"
import script from "./superuser_dashboard.vue?vue&type=script&lang=ts&"
export * from "./superuser_dashboard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90adaff2",
  null
  
)

export default component.exports